'use client';

import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';

export const SearchIconButton = ({ onClick }: { onClick: () => void }) => (
  <Button variant='ghost' size='icon' onClick={onClick}>
    <Search className='h-6 w-6' />
  </Button>
);
